module.exports = __webpack_public_path__ + "img/home-grid-info-f-guard.0be67eab.png";